// extracted by mini-css-extract-plugin
export default {"videoPageWrapper":"Video_videoPageWrapper__fvrlx","videoWrapper":"Video_videoWrapper__OtUpZ","videoBox":"Video_videoBox__pvf38"};